import { Page, Text, View } from '@react-pdf/renderer'
import { tw } from '~/components/pdfs'
import { getParcelLabelValues, Listing, type ParcelFeature } from '~/models'

export default function ReportPdfParcelPage({
  listing,
  parcels,
}: {
  listing: Listing
  parcels: ParcelFeature[]
}) {
  const parcel = parcels.find(
    (parcel) =>
      parcel &&
      parcel.properties.fields.parcelnumb === listing.property.parcelApn
  )
  if (!parcel) {
    return null
  }
  return (
    <Page size="LETTER" style={tw('p-8 font-sans')}>
      <Text style={tw('font-heading mb-4 text-xl font-semibold')}>
        Parcel Data
      </Text>
      <View style={tw('flex w-full flex-col text-sm')}>
        {getParcelLabelValues(parcel.properties).map(
          ({ key, label, value }) => {
            return (
              <View
                key={key}
                style={tw(
                  'flex flex-row gap-8 border-b border-gray-200 py-1.5'
                )}>
                <Text style={tw('w-2/5 font-medium leading-tight')}>
                  {label}:
                </Text>
                <Text style={tw('w-3/5')}>{value}</Text>
              </View>
            )
          }
        )}
      </View>
      <View>
        <Text style={tw('mt-4 text-xs italic text-gray-500')}>
          This information is provided by Regrid and is not maintained by
          Resimplifi
        </Text>
      </View>
    </Page>
  )
}
